import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";
import cartInquiryService from "../../../services/cart-inquiry.service";

import DataTable from "../../../components/data-table";
import { TextField } from "../../../components/formik-material-ui";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";



export default function ConfirmCartInquiryModal(props) {

    const {
        data = {},
        doRefresh = () => { },
        close = () => { }
    } = props;

    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "نام محصول",
                disableSort: true,
            },
            {
                field: "countObj",
                title: "درخواست / موجودی",
                disableSort: true,
                renderer: (v) => `د:${v.count} / م:${v.existCount}`,
            },
            {
                field: "discountFiled",
                title: "تخفیف",
            },
            {
                field: "removeFromCart",
                title: "حذف",
            },
        ],
        []
    );


    const [cartItems, setCartItems] = useState([]);
    const [state, setState] = useState({
        deliver: 15,
        notifType: { title: "تماس", value: "tel" }
    });

    const handleConfirm = async () => {
        const dataToSend = {
            deliverDate: state.deliver,
            notifType: state.notifType.value,
            cartItems: cartItems.map(it => ({ id: it.id, discount: it.discount, remove: !!it.remove })),
        }
        await cartInquiryService.answerdCartInquiry(data.id, dataToSend)
        doRefresh();
        close();
    }

    const getUserCart = () => {
        cartInquiryService.getUserCartDetail(data.userId).then(res => {
            setCartItems(res.data.items);
        })
    }

    const handleChangeDiscount = (cartId, discount) => {
        setCartItems(prev => {
            const changeCart = prev.find(item => item.id === cartId);
            if (changeCart) {
                changeCart.discount = parseInt(discount)
            }
            return [...prev]
        })
    }

    const handleRemoveFromCart = (cartId) => {
        setCartItems(prev => {
            const changeCart = prev.find(item => item.id === cartId);
            if (changeCart) {
                changeCart.remove = !changeCart.remove;
            }
            return [...prev]
        })
    }

    const mapToShow = (item) => {
        if (item.glassesSizeId) {
            const glass = item.glassesSize.glassesColor.glasses;
            return {
                title: (
                    <>
                        <span>{glass.category === "sunglass" ? "عینک افتابی" : "عینک طبی"}</span>
                        <span> - {glass.brand.name}</span>
                        <span> - {glass.name}</span>
                        <span> - {item?.glassesSize?.glassesColor?.name}</span>
                    </>
                ),
                countObj: { count: item.count, existCount: item.glassesSize.count },
                discountFiled: (
                    <TextField
                        type="number"
                        label="تخفیف٪"
                        value={item.discount || 0}
                        field={{
                            onChange: (e) => handleChangeDiscount(item.id, e.target.value)
                        }}
                        inputProps={{
                            min: 0,
                            max: 100,
                        }}
                    />
                ),
                removeFromCart: (
                    <Button onClick={() => handleRemoveFromCart(item.id)} color="red" style={{color: "red"}}>
                        { item.remove ? "بازگشت به سبد" : "حذف از سبد" }
                    </Button>
                )
            }
        }
    }

    const getOptionLabel = () => {
        const labelSelector = "title";
        if (!labelSelector) return;
        if (typeof labelSelector === "string") {
            return (option) => `${option[labelSelector]}`;
        }
        return labelSelector;
    };

    useEffect(() => {
        getUserCart()
    }, []);

    return (
        <>
            <DialogContent>
                <DataTable
                    title="تایید استعلام موجودی"
                    headCells={headerCells}
                    data={cartItems.map(mapToShow)}
                />

                <div className="container mt-3">
                    <div className="row d-flex">
                        <div className="col-4 me-2">
                            <TextField
                                type="number"
                                label="تعداد روز تحویل"
                                value={state.deliver}
                                field={{
                                    onChange: (e) => setState(prev => ({ ...prev, deliver: parseInt(e.target.value) }))
                                }}
                            />
                        </div>
                        <div className="col-4" style={{ width: "100%" }}>
                            <MuiAutocomplete
                                label="نوع اطلاع به کاربر"
                                multiple={false}
                                ignoreCase={true}
                                options={[
                                    { title: "پیامک", value: "sms" },
                                    { title: "تماس", value: "tel" }
                                ]}
                                value={state.notifType}
                                onChange={(e, values) => setState(prev => ({ ...prev, notifType: values }))}
                                getOptionLabel={getOptionLabel()}
                                defaultValue={[]}
                                noOptionsText="هیچ گزینه ای یافت نشد."
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        label={"نوع پاسخ"}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={close}>
                    لغو
                </Button>
                <Button
                    onClick={handleConfirm}
                    color="primary"
                >
                    تایید
                </Button>
            </DialogActions>
        </>
    )
}